import {
  Box, Button, Flex, Text
} from '@huspy/briks-web';
import { useDisclosure } from '@mantine/hooks';
import { BaseSlido } from '@modules/core/components/BaseSlido';
import { useTranslation } from 'react-i18next';
import useGetVaultConfig from '@modules/vault/hooks/queries/useVaultConfig';
import { OpportunityApplicant } from '@modules/opportunities/entities/opportunity/opportunity.entity';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';
import DocumentsChecklistV2 from './components/DocumentsChecklistV2';
import { VaultOverview } from './components/VaultOverview';

export const VaultConfiguration = ({
  opportunityId,
  mainApplicant,
  hasSelectedBanks,
  clientId,
}: {
  opportunityId: string;
  mainApplicant: OpportunityApplicant | undefined;
  hasSelectedBanks: boolean;
  clientId: string | undefined;
}) => {
  const [isOpen, { open, close }] = useDisclosure(false);
  const { t } = useTranslation();
  const { data, isLoading } = useGetVaultConfig(
    opportunityId,
    hasSelectedBanks
  );
  const fullName = `${mainApplicant?.first_name} ${mainApplicant?.last_name}`;

  const handleClick = () => {
    open();
    trackAmplitudeEvent(
      USER_EVENTS.VAULT.REQUEST_INFO_FROM_CLIENT_CLICKED,
      {
        case_id: opportunityId,
        client_id: clientId,
      }
    );
  };
  return (
    <>
      <Button
        variant='outline'
        onClick={ handleClick }
        disabled={ isLoading || !hasSelectedBanks }
        data-test='vault-config-btn'
      >
        {t('vault.config.slido.button')}
      </Button>
      <BaseSlido
        title={ (
          <Flex direction='column' gap='2' p='6'>
            <Text size='3xl'>
              {' '}
              {t('vault.config.slido.title')}
              {' '}
              {fullName}
            </Text>
            <Text size='md' color='neutral.500'>
              {t('vault.config.slido.subtitle')}
            </Text>
          </Flex>
        ) }
        opened={ isOpen }
        close={ close }
      >
        <VaultOverview
          opportunityId={ opportunityId }
          fullName={ fullName }
          email={ mainApplicant?.email }
          clientId={ clientId }
        />
        <Box p='6'>
          <DocumentsChecklistV2
            vaultData={ data! }
            oppId={ opportunityId }
            clientId={ clientId }
          />
        </Box>
      </BaseSlido>
    </>
  );
};
